import { UserGroupActions } from './actions'
import { UserGroupGetters } from './getters'
import { UserGroupMutations } from './mutations'
import { UserGroupState } from './state'

export const USER_GROUP_NAMESPACE = 'userGroup'

export const UserGroup = {
  namespaced: true,
  state: UserGroupState,
  actions: UserGroupActions,
  mutations: UserGroupMutations,
  getters: UserGroupGetters,
}
